import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomCurrencyPipe } from './currency.pipe';
import { IonicModule } from '@ionic/angular';

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [CustomCurrencyPipe],

  exports: [CustomCurrencyPipe],

  imports: [CommonModule, IonicModule],
})
export class CustomCurrencyPipeModule {}
